import { Button } from "@/components/ui/button";

const TugOfWarVoting = ({ redVotes, blueVotes, myVote, onVote, disabled }) => {
  const totalVotes = redVotes + blueVotes;
  const redPercent = totalVotes > 0 ? (redVotes / totalVotes) * 100 : 50;
  const bluePercent = totalVotes > 0 ? (blueVotes / totalVotes) * 100 : 50;

  return (
    <div className="space-y-4">
      {/* Voting Buttons */}
      <div className="flex gap-4">
        <Button
          data-testid="vote-red"
          onClick={() => onVote("red")}
          disabled={disabled}
          className={`flex-1 h-14 font-bold uppercase tracking-wider transition-all ${
            myVote === "red" 
              ? "bg-[#e11d48] text-white ring-2 ring-[#e11d48] ring-offset-2 ring-offset-background" 
              : "bg-[#e11d48]/20 text-[#e11d48] hover:bg-[#e11d48]/30 border border-[#e11d48]/30"
          }`}
        >
          Vote Red
          <span className="ml-2 mono text-sm opacity-80">{redVotes}</span>
        </Button>
        
        <Button
          data-testid="vote-blue"
          onClick={() => onVote("blue")}
          disabled={disabled}
          className={`flex-1 h-14 font-bold uppercase tracking-wider transition-all ${
            myVote === "blue" 
              ? "bg-[#3b82f6] text-white ring-2 ring-[#3b82f6] ring-offset-2 ring-offset-background" 
              : "bg-[#3b82f6]/20 text-[#3b82f6] hover:bg-[#3b82f6]/30 border border-[#3b82f6]/30"
          }`}
        >
          Vote Blue
          <span className="ml-2 mono text-sm opacity-80">{blueVotes}</span>
        </Button>
      </div>

      {/* Tug of War Bar */}
      <div className="relative">
        <div className="h-6 bg-zinc-800 rounded-full overflow-hidden flex voting-bar">
          <div 
            className="bg-gradient-to-r from-[#e11d48] to-[#e11d48]/80 voting-bar-fill flex items-center justify-start pl-3"
            style={{ width: `${redPercent}%` }}
          >
            {redPercent >= 15 && (
              <span className="text-xs font-bold text-white mono">{redPercent.toFixed(0)}%</span>
            )}
          </div>
          <div 
            className="bg-gradient-to-r from-[#3b82f6]/80 to-[#3b82f6] voting-bar-fill flex items-center justify-end pr-3"
            style={{ width: `${bluePercent}%` }}
          >
            {bluePercent >= 15 && (
              <span className="text-xs font-bold text-white mono">{bluePercent.toFixed(0)}%</span>
            )}
          </div>
        </div>
        
        {/* Center marker */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1 h-6 bg-white/30" />
      </div>
    </div>
  );
};

export default TugOfWarVoting;
